import { auditSwitchToRedesign } from "lib/analytics/auditEvents";
import { BASENAME } from "lib/routing";
import { getState } from "app/StoreFactory";
import { postPreferences } from "../api/postPrefrences";

export function switchDesign(tag) {
  postPreferences(getState().preferences);
  auditSwitchToRedesign(tag === "New");
  setTimeout(() => {
    const newPath = tag === "New" ? `${BASENAME}/Home` : `${BASENAME}/latest-research`;
    window.location.assign(newPath);
  }, 500);
}
